import { BROADCAST_SET_SCENE_LAYOUT, GET_BROADCAST } from 'actions/Types';

import * as SceneLayouts from 'constants/SceneLayouts';

export const initialState = SceneLayouts.SIDE_BY_SIDE;

export default (state = initialState, action) => {
  if (action.type === BROADCAST_SET_SCENE_LAYOUT) {
    return action.payload || state;
  }

  if (action.type === `${GET_BROADCAST}_SUCCESS`) {
    const { program } = action.payload;
    const selectedSceneLayout =
      SceneLayouts[program?._id] || SceneLayouts[program?.layout];
    return selectedSceneLayout || state;
  }

  return state;
};
